export const enLocale = {
  tableForm: {
    search: 'Buscar',
    reset: 'Limpar',
    submit: 'Enviar',
    collapsed: 'Reduzir',
    expand: 'Expandir',
    inputPlaceholder: 'Digite algo',
    selectPlaceholder: 'Selecione algo',
  },
  alert: {
    clear: 'Limpar',
  },
};
